import { createAsyncThunk } from '@reduxjs/toolkit';
import { apiClient } from 'src/api/apiClient';
import { GET_CREDIT } from 'src/constants/httpEndPoints';

export const getLatestCredit = createAsyncThunk(
  'login/get-latest-credit',
  async ({ emailId, customerId, isSuperAdmin }: { emailId: string; customerId: string; isSuperAdmin?: boolean }, { getState }) => {
    const state: any = getState();
    const userLevelCredit: boolean = state?.featureFlags?.userLevelCredit;

    const headers = {
      headers: {
        'X-USER-EMAIL': emailId,
        'X-CUSTOMER-ID': customerId,
      },
    };

    try {
      const apiUrl = (isSuperAdmin || !userLevelCredit) ? GET_CREDIT : `${GET_CREDIT}?user_scoped=true`;
      const res = await apiClient.get(apiUrl, headers);
      if (res.status !== 200) {
        throw new Error('API call failed with status ' + res.status);
      }
      const newCredit = res.data.balance;
      return newCredit;
    } catch (err: any) {
      console.error(err);
      throw new Error("API call failed");
    }
  }
);
